import { type PillarFormInputComponentConfig } from "shared/components/pillar-form/PillarFormInputComponentConfig";

/**
 * True when a surveyjs-like config element should render as a date/time input.
 *
 * Matches any `type` containing "date" (e.g. "date", "datetime-local"), or a
 * `type` such as "text" narrowed to a date by an `inputType` of "date".
 */
export const isDynamicDateTimeInput = (
  element: PillarFormInputComponentConfig,
): boolean => {
  const type = String(element.type || "").toLowerCase();
  const inputType = String(element.inputType || "").toLowerCase();

  return type.includes("date") || inputType === "date";
};
